class ConvertXml {
  async xmlString(xml) {
    if (xml.type === 'text/xml') {
      const result = await new Promise((resolve) => {
        const xmlString = xml;
        let reader = new FileReader();
        reader.readAsText(xmlString);

        reader.onload = function (e) {
          return resolve(e.target.result);
        };
      });
      return result;
    } else {
      return null
    }
  }

  ObjectPurchase(object) {
    const purchase = {
      fornecedor: null,
      produtos: null,
      purchase: null,
      key: 0,
      impostos: null,
      valorNfe: 0,
      valorFrete: 0
    };

    const paths = [
      object.data?.nfeProc?.NFe?.[0]?.infNFe?.[0],
      object.data?.NFe?.infNFe?.[0],
      object.data?.enviNFe?.NFe?.[0]?.infNFe?.[0]
    ];

    const infNFe = paths.find(Boolean);
    const protNFe = object.data?.nfeProc?.protNFe?.[0]?.infProt?.[0];

    if (infNFe) {
      purchase.fornecedor = infNFe.emit ?? null;
      purchase.produtos = infNFe.det ?? null;
      purchase.purchase = infNFe.ide ?? null;
      purchase.impostos = infNFe.total?.[0]?.ICMSTot ?? null;

      const icmsTot = infNFe.total?.[0]?.ICMSTot?.[0] ?? {};
      purchase.valorNfe = Number(icmsTot.vNF?.[0] ?? 0);
      purchase.valorFrete = Number(icmsTot.vFrete?.[0] ?? 0);
    }

    if (protNFe) {
      purchase.key = protNFe.chNFe ?? 0;
    } else if(infNFe?.$?.Id) {
      purchase.key = [infNFe?.$?.Id?.replace('NFe', '')] ?? 0;
    }

    return purchase;
  }
}

export default new ConvertXml()

